export default "__VITE_ASSET__Dd3um9Ht__"